import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
} from "reactstrap"
import { Link } from "react-router-dom"

import classNames from "classnames"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

//i18n
import { withTranslation } from "react-i18next"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"

const Dashboard = props => {
  const [modal, setModal] = useState(false)

  const DashboardProperties = createSelector(
    state => state.Dashboard,
    dashboard => ({
      chartsData: dashboard.chartsData,
    })
  )

  //meta title
  document.title = "Dashboard | " + (process.env.REACT_APP_CMS_TITLE || "DELPHI")

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Dashboards")}
            breadcrumbItem={props.t("Dashboard")}
          />

          {/* <iframe title="AI Shopping" width="100%" height="800px" src="https://app.powerbi.com/view?r=eyJrIjoiOWI3NDRjNzQtZGRkYi00YjYzLWJiZTQtYTFlZjJjZjlkYTM0IiwidCI6IjY3NDBjNGQ3LTdmMDgtNDk2ZC04ZDMwLTE5NTUxMTc1MWUwNSIsImMiOjEwfQ%3D%3D" frameBorder="0" allowFullScreen="true"></iframe> */}
          <iframe
            title="AI Shopping 3"
            width="100%"
            height="800px"
            src="https://app.powerbi.com/view?r=eyJrIjoiMmEzN2UyNjYtNTRmYy00ZDMzLTk1ZTYtNGFjZWM5MzRlYTU1IiwidCI6IjY3NDBjNGQ3LTdmMDgtNDk2ZC04ZDMwLTE5NTUxMTc1MWUwNSIsImMiOjEwfQ%3D%3D"
            allowFullScreen="true"
          ></iframe>
        </Container>
      </div>
    </React.Fragment>
  )
}

Dashboard.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(Dashboard)
